import React, { useEffect, useState } from "react";
import Select, { SingleValue, MultiValue, components } from "react-select";
import styled from "styled-components";
import LoaderCircle from "../../loaders/LoaderCircle";

const SelectInputMap: React.FC<SelectInputMapProps> = ({
  placeholder = "",
  label = undefined,
  options = [],
  onChange = () => { },
  onSearchChange = () => { },
  isLoading = false,
  initSelectedValue,
  selectedValue,
  onClear,
  isDisabled = false,
}) => {
  // const [selectedValue, setSelectedValue] = useState<
  //   SingleValue<OptionType> | MultiValue<OptionType>
  // >(null);

  const handleSelectChange = (value: SingleValue<OptionType> | MultiValue<OptionType>) => {
    console.log(22222, value)
    onChange(value);
    //setSelectedValue(value);
  };

  const handleClear = () => {
    //setSelectedValue(null);
    onChange(null);
    if (!!onClear) {
      onClear();
    }
  };

  useEffect(() => {
    if (initSelectedValue) {
      //setSelectedValue(initSelectedValue);
    }
  }, [initSelectedValue])

  return (
    <Wrapper>
      {label && <Label>{label}</Label>}
      <Select
        options={options}
        placeholder={placeholder}
        value={selectedValue}
        onChange={handleSelectChange}
        onInputChange={(newValue) => {
          onSearchChange(newValue);
        }}
        styles={customStyles}
        isDisabled={isDisabled}
        noOptionsMessage={() => "Не найдено"}
        isClearable={!!onClear} // Включаем встроенную кнопку очистки
        // onMenuClose={handleClear} // Сбрасываем значение при закрытии меню (если нужно)
        components={{
          DropdownIndicator: (props) => (
            isLoading ? <LoaderWrapper><LoaderCircle /></LoaderWrapper> : <components.DropdownIndicator {...props} />
          ), // Показать Loader вместо DropdownIndicator
          IndicatorSeparator: () => null, // Убираем разделитель индикаторов
          ClearIndicator: (props) => {
            return (
              <ClearButton onClick={onClear}>x</ClearButton>
            );
          }, // Кастомная кнопка очистки
        }}
      />
    </Wrapper>
  );
};

export default SelectInputMap;

export interface OptionType {
  value: string;
  label: string;
}

interface SelectInputMapProps {
  placeholder?: string;
  label?: string;
  options?: OptionType[];
  onChange?: (
    value: SingleValue<OptionType> | MultiValue<OptionType> | OptionType
  ) => void;
  onSearchChange?: (value: string | undefined) => void;
  isLoading?: boolean;
  initSelectedValue?: any;
  selectedValue: SingleValue<OptionType> | MultiValue<OptionType> | null | undefined;
  onClear?: () => void;
  isDisabled?: boolean;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const Label = styled.span`
   display: block;
    margin-right: 6px;
    color: #9DA3B5;
    font-size: 12px;
    font-weight: 300;
    text-align: left;
`;

const LoaderWrapper = styled.div`
    margin: 5px 5px 0 0;
    `

const customStyles = {
  control: (baseStyles: any, state: any) => ({
    ...baseStyles,
    borderColor: state.isFocused ? "#9DA3B5" : "#9DA3B5",
    borderRadius: 8,
    textAlign: "left",
    fontSize: 14,
    width: 280,
    minHeight: 35,
  }),
  menuList: (base: any) => ({
    ...base,
    textAlign: "left",
  }),
  option: (base: any, state: any) => ({
    ...base,
    textAlign: "left",
  }),
  dropdownIndicator: (base: any) => ({
    ...base,
    height: 35,
  }),
  indicatorsContainer: (base: any) => ({
    ...base,
    height: 35,
  }),
};

const CustomDropdownIndicator = (props: any) => {
  const { isLoading } = props.selectProps;
  return !isLoading ? (
    <LoaderCircle />
  ) : (
    <components.DropdownIndicator {...props} />
  );
};

const ClearButton = styled.p`
  cursor: pointer;
  color: #9DA3B5;
  font-size: 18px;
  font-weight: '700';
  &:hover {
    color: #000;
  }
`;